/**
 * Used for rendering client library list 
 * view with the ability to toggle between
 * a module/grid view and a list view
 */

import ClientLibraryListSort from "../react/ClientLibraryListSort"
import ClientLibraryModuleSort from "../react/ClientLibraryModuleSort"

export default class DualListView {
  constructor(opts = {}) {
    this.sortTypeString = opts.initial || "list"
    this.sortType = this.setSort()[this.sortTypeString]
    this.statuses = $(".js-list-status").map((i, ele) => {
      return $(ele).data("status");
    }).toArray()
    this.roleType = opts.roleType

    this.setupSortFilters();
    this.setupInitialListIcons();
    this.bindToggle();
  }

  bindToggle() {
    N2.handle('click', '.js-list-view-type', (e) => {
      $(`.js-list-icon-${$(e.target).data('status')}`).addClass('grey-text text-lighten-2')
      $(e.target).removeClass('grey-text text-lighten-2')
      this.sortTypeString = $(e.target).data('viewType')

      this.reRender($(e.target))
    })
  }

  reRender($target) {
    this.sortType = this.setSort()[this.sortTypeString]
    this.setupSortFilters($target.data('status'))
  }

  setSort() {
    return { list: ClientLibraryListSort, module: ClientLibraryModuleSort } 
  }

  setView() {
    return { list: ClientLibraryListView, module: ClientLibraryModuleView }
  }

  setupSortFilters(key = null) {
    const keys = key ? [key] : this.statuses;
    const klass = this.sortType;
    this.sortAds(keys, klass);
  }

  setupInitialListIcons() {
    const inactive = this.sortTypeString === "list" ? "module" : "list";
    $.each(this.statuses, (_, status) => {
      $(`.js-list-icon-${status}[data-view-type='${inactive}']`).addClass("grey-text text-lighten-2");
    });
  }

  sortAds(keys, klass) {
    keys.forEach((ele) => {
      if ($(`.js-ads-react-data-${ele}`).length) {
        let list = new klass({
          sortScope: `#sort-filters-${ele}`,
          selector: `.js-ads-list-${ele}`,
          data: $(`.js-ads-react-data-${ele}`).data("jobs"),
          roleType: this.roleType,
        });
        list.render()
      }
    });
  }
}
